(function(){var SHOW=12,CATEGORIES=["labware","instruments","consumables","microbiological-media","chemicals","safety"],PER_CATEGORY=2;function rootPath(){var root=window.routes&&window.routes.rootUrl||"/";return root==="/"?"":root.replace(/\/$/,"")}function productImage(p){var src="";if(typeof p.featured_image=="string")src=p.featured_image;else if(p.featured_image&&(p.featured_image.src||p.featured_image.url))src=p.featured_image.src||p.featured_image.url;else if(p.images&&p.images.length){var im=p.images[0];src=typeof im=="string"?im:im.src||im.url||""}return src?(src.indexOf("//")===0&&(src="https:"+src),src):""}function productPrice(p){var raw=null;if(p.variants&&p.variants[0]&&p.variants[0].price!=null?raw=p.variants[0].price:p.price!=null&&(raw=p.price),raw==null)return"";var s=String(raw),n=parseFloat(s);if(isNaN(n))return"";if(s.indexOf(".")===-1&&n>=100)n=n/100;var parts=n.toFixed(2).split("."),whole=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,".");return"\u20AC"+whole+","+parts[1]}function escapeHtml(str){return String(str||"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;")}function customerLoggedIn(){return !!document.querySelector("[data-lx-logged-in]")}function isNexopart(p){return String((p&&p.vendor)||"").toLowerCase().indexOf("nexopart")!==-1}function loginForPrice(productPath){var sample=document.querySelector(".lx-login-price"),label=sample?(sample.textContent||"").replace(/\s+/g," ").trim():"",lang=(document.documentElement.lang||"").toLowerCase();label||(label=lang.indexOf("nl")===0?"Log in voor prijs":lang.indexOf("fr")===0?"Connexion pour le prix":"Login for price");var href="";if(sample){try{var u=new URL(sample.getAttribute("href")||"",location.origin);u.searchParams.set("return_to",productPath);href=u.pathname+u.search}catch(e){}}href||(href="/customer_authentication/login?return_to="+encodeURIComponent(productPath));return '<a href="'+escapeHtml(href)+'" class="lx-login-price button button--secondary button--small" rel="nofollow">'+escapeHtml(label)+"</a>"}function card(p,root){var img=productImage(p),price=productPrice(p),url=root+"/products/"+encodeURIComponent(p.handle),title=escapeHtml(p.title),html='<div class="product-item product-item--vertical">';html+='<a href="'+url+'" class="product-item__image-wrapper">';html+='<div class="aspect-ratio" style="padding-bottom:100%">';img&&(html+='<img class="product-item__primary-image" loading="lazy" src="'+img+'" alt="'+title+'">');html+="</div></a>";html+='<div class="product-item__info"><div class="product-item__info-inner">';html+='<a href="'+url+'" class="product-item__title text--strong link">'+title+"</a>";isNexopart(p)&&!customerLoggedIn()?html+='<div class="product-item__price-list price-list">'+loginForPrice(url)+"</div>":price&&(html+='<div class="product-item__price-list price-list"><span class="price">'+price+"</span></div>");html+="</div></div></div>";return html}function shuffle(arr){for(var i=arr.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1)),t=arr[i];arr[i]=arr[j],arr[j]=t}return arr}function pickFrom(products,count){var usable=products.filter(function(p){return productImage(p)&&productPrice(p)});return shuffle(usable),usable.slice(0,count)}function randomizeFeatured() {
  /* lx-home-instant: the homepage grid is painted while the page parses. */
}

function collectionHandle(){var m=location.pathname.match(/\/collections\/([^\/?#]+)/);return m&&decodeURIComponent(m[1])||""}function shuffleList(list){var cards=Array.prototype.slice.call(list.children);cards.length<2||(shuffle(cards),cards.forEach(function(el){list.appendChild(el)}))}function markSortFeatured(){var params=new URLSearchParams(location.search);if(params.get("sort_by")!=="manual"){params.set("sort_by","manual");var q=params.toString();history.replaceState({},"",location.pathname+(q?"?"+q:"")+location.hash)}var picker=document.getElementById("sort-by-selector"),featuredName="Featured";picker&&picker.querySelectorAll('[data-action="select-value"]').forEach(function(btn){var on=btn.getAttribute("data-value")==="manual";if(btn.classList.toggle("is-selected",on),on){var copy=btn.cloneNode(!0);copy.querySelectorAll("svg, .icon").forEach(function(n){n.remove()}),featuredName=(copy.textContent||"Featured").replace(/\s+/g," ").trim()||"Featured"}}),document.querySelectorAll(".collection__toolbar-item--sort .hidden-phone").forEach(function(el){el.textContent=el.textContent.replace(/:[\s\S]*$/,": "+featuredName)}),document.querySelectorAll('input[name="sort_by"]').forEach(function(i){i.value="manual"})}function mixAllCollection(list,count){var root=rootPath(),handles=CATEGORIES.slice();handles.indexOf("chromatography")===-1&&handles.push("chromatography"),shuffle(handles),handles=handles.slice(0,4);var fetches=handles.map(function(handle){var page=1+Math.floor(Math.random()*6);return fetch(root+"/collections/"+handle+"?page="+page,{credentials:"same-origin"}).then(function(r){return r.ok?r.text():""}).then(function(html){if(!html)return[];var doc=new DOMParser().parseFromString(html,"text/html"),src=doc.querySelector(".product-list--collection");return src?Array.prototype.slice.call(src.children).map(function(el){return document.importNode(el,!0)}):[]}).catch(function(){return[]})});return Promise.all(fetches).then(function(groups){for(var mixed=[],seen={},i=0,added=!0;added&&mixed.length<count*2;)added=!1,groups.forEach(function(g){if(!(i>=g.length)){var el=g[i],a=el.querySelector&&el.querySelector('a[href*="/products/"]'),href=a?a.getAttribute("href"):"";if(href){if(seen[href])return;seen[href]=!0}mixed.push(el),added=!0}}),i+=1;return shuffle(mixed),mixed.length?(list.innerHTML="",mixed.slice(0,count).forEach(function(el){list.appendChild(el)}),!0):!1})}function randomizeCollection(){if(/\/collections\//.test(location.pathname)){var handle=collectionHandle();if(!(handle==="vendors"||handle==="types")){var params=new URLSearchParams(location.search),sort=params.get("sort_by"),list=document.querySelector('[data-section-type="collection"] .product-list--collection')||document.querySelector(".product-list--collection");if(list){if(handle==="all"){if(sort&&sort!=="manual")return;markSortFeatured();var count=list.children.length||24;list.style.visibility="hidden";var show=function(){list.style.visibility=""},t=setTimeout(function(){shuffleList(list),show()},2500);mixAllCollection(list,count).then(function(ok){clearTimeout(t),ok||shuffleList(list),show()}).catch(function(){clearTimeout(t),shuffleList(list),show()});return}if(!(sort&&sort!=="manual")){var cards=Array.prototype.slice.call(list.children);cards.length<2||(shuffle(cards),cards.forEach(function(el){list.appendChild(el)}))}}}}}function normalizeFooterContactIcons(){var links=document.querySelectorAll('.footer a[href^="tel:"], .footer a[href^="mailto:"]');if(links.length){var rows=[];links.forEach(function(link){var icon=null,prev=link.previousElementSibling,next=link.nextElementSibling;prev&&prev.classList&&(prev.classList.contains("icon--bi-phone")||prev.classList.contains("icon--bi-email"))?icon=prev:next&&next.classList&&(next.classList.contains("icon--bi-phone")||next.classList.contains("icon--bi-email"))&&(icon=next),rows.push({icon:icon,link:link})});var host=rows[0].link.closest("p");if(!(!host||host.classList.contains("footer-contact-rows"))){var wrap=document.createElement("div");wrap.className="footer-contact-rows",rows.forEach(function(row){var line=document.createElement("div");line.className="footer-contact-row",row.icon&&line.appendChild(row.icon),line.appendChild(row.link),wrap.appendChild(line)}),host.parentNode.insertBefore(wrap,host),host.remove()}}}var lastShipPct=null;function readShipPct(root){var bar=(root||document).querySelector(".lx-ship-progress");if(!bar)return null;var raw=bar.getAttribute("data-progress"),n=parseFloat(raw);return isNaN(n)?0:Math.max(0,Math.min(100,n))}function animateShipProgress(){var to=readShipPct(document);if(to!=null){var from=lastShipPct;lastShipPct=to,!(from==null||Math.abs(from-to)<.2)&&document.querySelectorAll(".lx-ship-progress").forEach(function(bar){var fill=bar.querySelector(".lx-ship-progress__fill"),dot=bar.querySelector(".lx-ship-progress__dot");fill&&(fill.style.transition="none",dot&&(dot.style.transition="none"),fill.style.width=from+"%",dot&&(dot.style.left=from+"%"),bar.classList.toggle("is-unlocked",to>=99.5),requestAnimationFrame(function(){requestAnimationFrame(function(){fill.style.transition="width .7s cubic-bezier(0.22, 1, 0.36, 1)",dot&&(dot.style.transition="left .7s cubic-bezier(0.22, 1, 0.36, 1), background .7s ease"),fill.style.width=to+"%",dot&&(dot.style.left=to+"%")})}))})}}function isPhone(){return window.matchMedia("(max-width: 640px)").matches}var pageScrollY=0,pageScrollLocked=!1;function lockPageScroll(){pageScrollLocked||(pageScrollY=window.scrollY||document.documentElement.scrollTop||0,pageScrollLocked=!0,document.documentElement.classList.add("lx-cart-open"),document.documentElement.style.overflow="hidden",document.body.style.overflow="hidden",document.body.style.position="fixed",document.body.style.top="-"+pageScrollY+"px",document.body.style.left="0",document.body.style.right="0",document.body.style.width="100%")}function unlockPageScroll(){pageScrollLocked&&(pageScrollLocked=!1,document.documentElement.classList.remove("lx-cart-open"),document.documentElement.style.overflow="",document.body.style.overflow="",document.body.style.position="",document.body.style.top="",document.body.style.left="",document.body.style.right="",document.body.style.width="",window.scrollTo(0,pageScrollY))}function pinPhoneCart(cart){if(!(!cart||!isPhone())){cart.style.setProperty("position","fixed","important"),cart.style.setProperty("right","auto","important"),cart.style.setProperty("bottom","auto","important"),cart.style.setProperty("margin","0px","important"),cart.style.setProperty("transform","none","important"),cart.style.setProperty("width",window.innerWidth+"px","important"),cart.style.setProperty("max-width",window.innerWidth+"px","important"),cart.style.setProperty("height",window.innerHeight+"px","important"),cart.style.setProperty("max-height",window.innerHeight+"px","important"),cart.style.setProperty("left","0px","important"),cart.style.setProperty("top","0px","important");var box=cart.getBoundingClientRect();(Math.abs(box.left)>1||Math.abs(box.top)>1)&&(cart.style.setProperty("left",-box.left+"px","important"),cart.style.setProperty("top",-box.top+"px","important"))}}function containCartScroll(cart){!cart||cart.dataset.lxScrollBound||(cart.dataset.lxScrollBound="1",cart.addEventListener("wheel",function(event){var list=cart.querySelector(".mini-cart__line-item-list")||cart,delta=event.deltaY,atTop=list.scrollTop<=0,atBottom=list.scrollTop+list.clientHeight>=list.scrollHeight-1;(list!==cart&&!list.contains(event.target)||delta<0&&atTop||delta>0&&atBottom)&&event.preventDefault(),event.stopPropagation()},{passive:!1}),cart.addEventListener("touchmove",function(event){event.stopPropagation()},{passive:!0}))}function syncMiniCartChrome(){var cart=document.getElementById("mini-cart"),open=!!(cart&&cart.getAttribute("aria-hidden")==="false");document.documentElement.classList.toggle("lx-cart-open",open);var leftover=document.querySelector(".lx-minicart-backdrop");if(leftover&&leftover.remove(),cart&&open){cart.style.setProperty("visibility","visible","important"),cart.style.setProperty("opacity","1","important"),cart.style.setProperty("pointer-events","auto","important"),cart.style.maxHeight="100dvh",cart.style.height="100dvh",cart.style.top="0px";var content=cart.querySelector(".mini-cart__content");content&&(content.style.maxHeight="none"),containCartScroll(cart),lockPageScroll(),isPhone()&&(pinPhoneCart(cart),requestAnimationFrame(function(){pinPhoneCart(cart)}))}else cart&&(cart.style.setProperty("visibility","hidden","important"),cart.style.setProperty("opacity","0","important"),cart.style.setProperty("pointer-events","none","important"),unlockPageScroll())}function watchMiniCartLock(){var cart=document.getElementById("mini-cart");cart&&new MutationObserver(syncMiniCartChrome).observe(cart,{attributes:!0,attributeFilter:["aria-hidden"]}),document.addEventListener("product:added",function(){[80,250,550,900].forEach(function(ms){setTimeout(syncMiniCartChrome,ms)})}),window.addEventListener("resize",function(){var openCart=document.getElementById("mini-cart");openCart&&openCart.getAttribute("aria-hidden")==="false"&&pinPhoneCart(openCart)}),document.addEventListener("click",function(event){event.target.closest('[data-action="toggle-mini-cart"], .lx-minicart-close, .header__cart-toggle')&&(setTimeout(syncMiniCartChrome,0),setTimeout(syncMiniCartChrome,40))},!0),syncMiniCartChrome(),lastShipPct=readShipPct(document),cart&&new MutationObserver(function(){animateShipProgress()}).observe(cart,{childList:!0,subtree:!0}),document.addEventListener("cart:rerendered",animateShipProgress),document.addEventListener("product:added",function(){setTimeout(animateShipProgress,120),setTimeout(animateShipProgress,400)})}function attachQuoteQty(){document.addEventListener("click",function(event){var link=event.target.closest("[data-quote-product]");if(link){var form=link.closest("form")||document,qty=form.querySelector('input[name="quantity"]');try{var url=new URL(link.getAttribute("href"),window.location.origin);qty&&qty.value&&url.searchParams.set("qty",qty.value),link.setAttribute("href",url.pathname+url.search)}catch(err){}}},!0)}function packSizeFromText(text){var s=String(text||"").replace(/\s+/g," ").trim(),plus=s.match(/(\d+)\s*\+/);if(plus)return parseInt(plus[1],10);var num=s.match(/^(\d+)\b/);return num?parseInt(num[1],10):1}function packControlText(input,group){if(input.getAttribute("data-lx-pack-size"))return input.getAttribute("title")||"";var label=null;return input.id&&(label=group.querySelector('label[for="'+input.id.replace(/"/g,"")+'"]')),label||(label=input.nextElementSibling),!label||!label.tagName?"":label.getAttribute("title")||label.textContent||""}function packControls(group){var out=[];group.querySelectorAll('input.product-form__single-selector[type="radio"], input.product-form__single-selector[type="hidden"]').forEach(function(input){var attrSize=parseInt(input.getAttribute("data-lx-pack-size"),10),text=packControlText(input,group),size=attrSize>0?attrSize:packSizeFromText(text);out.push({input:input,size:size,hasPlus:/\d+\s*\+/.test(text)||attrSize>1,text:text})});var select=group.querySelector("select.product-form__single-selector");return select&&Array.prototype.forEach.call(select.options,function(opt){var text=opt.textContent||"",attrSize=parseInt(opt.getAttribute("data-lx-pack-size"),10),size=attrSize>0?attrSize:packSizeFromText(text);out.push({select:select,option:opt,size:size,hasPlus:/\d+\s*\+/.test(text)||attrSize>1,text:text})}),out}function isPackGroup(group){if(!group)return!1;if(group.getAttribute("data-lx-pack-option")==="true")return!0;var nameEl=group.querySelector(".product-form__option-name"),name=(nameEl?nameEl.textContent:"").toLowerCase();if(name.indexOf("value pack")!==-1||name.indexOf("waardepakket")!==-1||name.indexOf("waarde pack")!==-1)return!0;var controls=packControls(group);return controls.length<2?!1:controls.some(function(c){return c.hasPlus&&c.size>=2})}function formOf(el){return!el||!el.closest?document.querySelector("form.product-form"):el.closest("form.product-form")||el.closest("product-form")||document.querySelector("form.product-form")}function qtyInput(form){return!form||!form.querySelector?null:form.querySelector('quantity-picker input[name="quantity"]')||form.querySelector('.quantity-selector--product input[name="quantity"]')||form.querySelector('input[name="quantity"][type="number"]')}function syncValuePacks(){if(document.getElementById("main-cart"))return;var fromPack=!1,fromQty=!1,pendingQty=null;function setQty(form,n){var input=qtyInput(form);input&&(n=Math.max(1,parseInt(n,10)||1),parseInt(input.value,10)!==n&&(fromPack=!0,input.value=String(n),input.dispatchEvent(new Event("input",{bubbles:!0})),input.dispatchEvent(new Event("change",{bubbles:!0})),fromPack=!1))}function matchForQty(controls,qty){for(var sorted=controls.slice().sort(function(a,b){return b.size-a.size}),i=0;i<sorted.length;i++)if(qty>=sorted[i].size)return sorted[i];return sorted[sorted.length-1]||null}function paintPack(form,qty,opts){if(form){opts=opts||{};var dispatch=!!opts.dispatch,setChecked=opts.setChecked!==!1;qty=parseInt(qty,10)||1,form.querySelectorAll(".product-form__option").forEach(function(group){if(isPackGroup(group)){var controls=packControls(group),match=matchForQty(controls,qty);if(match){controls.forEach(function(c){var on=c===match||match.input&&c.input===match.input||match.option&&c.option===match.option||c.size===match.size;if(c.input){var label=c.input.id?group.querySelector('label[for="'+c.input.id+'"]'):c.input.nextElementSibling;setChecked&&on&&(c.input.checked?c.input.checked=!0:(c.input.checked=!0,dispatch&&(fromQty=!0,c.input.dispatchEvent(new Event("change",{bubbles:!0})),fromQty=!1))),label&&label.classList&&label.classList.toggle("is-selected",!!on)}else setChecked&&c.select&&c.option&&on&&c.select.value!==c.option.value&&(dispatch?(fromQty=!0,c.select.value=c.option.value,c.select.dispatchEvent(new Event("change",{bubbles:!0})),fromQty=!1):c.select.value=c.option.value)});var nameVal=group.querySelector(".product-form__selected-value");if(nameVal){var text=(match.text||"").trim();!text&&match.input&&(text=packControlText(match.input,group).trim()),text&&(nameVal.textContent=text)}}}})}}function applyPackForQty(form,qty){fromPack||!form||paintPack(form,qty,{dispatch:!0})}function sizeFromPackTarget(target){var group=target.closest(".product-form__option");if(!group)return 1;if(target.tagName==="SELECT"){var opt=target.selectedOptions&&target.selectedOptions[0],attr=opt&&parseInt(opt.getAttribute("data-lx-pack-size"),10);return attr>0?attr:packSizeFromText(opt&&opt.textContent)}var attrSize=parseInt(target.getAttribute("data-lx-pack-size"),10);return attrSize>0?attrSize:packSizeFromText(packControlText(target,group))}function restorePending(form){pendingQty==null||!form||(setQty(form,pendingQty),paintPack(form,pendingQty,{setChecked:!0,dispatch:!1}))}document.addEventListener("click",function(event){event.target.closest('[data-action="decrease-picker-quantity"], [data-action="increase-picker-quantity"]')&&(pendingQty=null);var label=event.target.closest(".product-form__option label.block-swatch__item");if(label){var group=label.closest(".product-form__option");if(isPackGroup(group)){var radio=label.control||label.htmlFor&&document.getElementById(label.htmlFor)||label.previousElementSibling;if(!(!radio||!radio.matches||!radio.matches(".product-form__single-selector"))){var size=sizeFromPackTarget(radio);pendingQty=size,paintPack(formOf(radio),size,{setChecked:!1})}}}},!0),document.addEventListener("input",function(event){var target=event.target;fromPack||target&&target.matches&&target.matches('quantity-picker input[name="quantity"], .quantity-selector--product input[name="quantity"]')&&(pendingQty=null)}),document.addEventListener("change",function(event){var target=event.target;if(!(!target||!target.matches)){if(target.matches('quantity-picker input[name="quantity"], .quantity-selector--product input[name="quantity"]')){if(fromPack)return;var form=formOf(target);if(pendingQty!=null){restorePending(form);return}applyPackForQty(form,target.value);return}if(target.matches(".product-form__single-selector")){if(fromQty)return;var group=target.closest(".product-form__option");if(!isPackGroup(group))return;var size=sizeFromPackTarget(target);pendingQty=size;var form=formOf(target);paintPack(form,size,{setChecked:!1}),setQty(form,size)}}}),document.addEventListener("variant:changed",function(event){var form=event.target;(!form||!form.querySelector)&&(form=document.querySelector("form.product-form")),restorePending(form)}),document.addEventListener("product:rerender",function(event){var form=event.target;(!form||!form.querySelector)&&(form=document.querySelector("form.product-form"));var size=pendingQty;requestAnimationFrame(function(){if(size!=null)pendingQty=size,restorePending(formOf(form)||form),pendingQty=null;else{var input=qtyInput(form);input&&paintPack(form,input.value,{setChecked:!0,dispatch:!1})}})})}function init(){normalizeFooterContactIcons(),randomizeFeatured(),randomizeCollection(),watchMiniCartLock(),attachQuoteQty(),syncValuePacks()}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",init):init()})(),(function(){function pair(){document.querySelectorAll(".rte").forEach(function(rte){if(!rte.querySelector(".lx-kf-tech")){var tech=rte.querySelector("[data-lx-tech]");if(tech){var h3=null;rte.querySelectorAll("h3").forEach(function(h){/key features/i.test(h.textContent||"")&&(h3=h)});var wrap=document.createElement("div");wrap.className="lx-kf-tech";var left=document.createElement("div");if(left.className="lx-kf-tech__features",h3){for(var node=h3,move=[];node&&node!==tech;){var next=node.nextElementSibling;move.push(node),node=next}tech.parentNode.insertBefore(wrap,tech),move.forEach(function(n){left.appendChild(n)})}else Array.prototype.slice.call(rte.children).forEach(function(n){n!==tech&&left.appendChild(n)}),rte.appendChild(wrap);wrap.appendChild(left),wrap.appendChild(tech)}}})}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",pair):pair()})(),(function(){function sync(el){!el||!el.classList||!el.classList.contains("form__field")||el.classList.toggle("is-filled",String(el.value||"").trim()!=="")}function scan(){document.querySelectorAll(".form__field").forEach(sync)}document.addEventListener("input",function(e){sync(e.target)},!0),document.addEventListener("change",function(e){sync(e.target)},!0),document.addEventListener("blur",function(e){sync(e.target)},!0),document.readyState==="loading"?document.addEventListener("DOMContentLoaded",scan):scan()})(),(function(){try{var u=new URL(location.href);if(u.pathname.indexOf("/collections/vendors")!==-1){var q=(u.searchParams.get("q")||"").trim();if(/^A\s*&\s*D\s+Instruments$/i.test(q)){u.searchParams.set("q","A&D"),location.replace(u.toString());return}}}catch(e){}var HIDE={unspsc:1,"unspsc code":1,tags:1,"sort by":1,"ghs symbols":1,"focus keyword":1,"weee category":1,"weee number":1};function isVendorPage(){return location.pathname.indexOf("/collections/vendors")!==-1}function hideJunk(){document.querySelectorAll(".cloud-search-filter__name").forEach(function(el){var t2=(el.textContent||"").replace(/\s+/g," ").trim().toLowerCase();if(t2=t2.replace(/:.*/,"").trim(),HIDE[t2]||isVendorPage()&&t2==="brand"){var box=el.closest(".cloud-search-filter");box&&(box.style.display="none")}})}function layout(){if(!(window.theme&&window.theme.pageType==="product")){var controls=document.querySelector(".cloud-search-page-controls--collection-page, .cloud-search-page-controls.cloud-search-filters-horizontal"),grid=document.querySelector(".product-list--collection, .product-list");if(!(!controls||!grid)){if(controls.closest(".lx-collection-with-filters")){hideJunk();return}var wrap=document.createElement("div");wrap.className="lx-collection-with-filters",grid.parentNode.insertBefore(wrap,grid),wrap.appendChild(controls),wrap.appendChild(grid),hideJunk()}}}function run(){layout(),hideJunk()}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",run):run();var t=0,obs=new MutationObserver(function(){t||(t=1,setTimeout(function(){t=0,run()},80))});document.body&&obs.observe(document.body,{childList:!0,subtree:!0})})(),(function(){var DATA=null,box=null;function locale(){var l=(document.documentElement.lang||"en").toLowerCase();return l.indexOf("nl")===0?"nl":l.indexOf("de")===0?"de":l.indexOf("fr")===0?"fr":"en"}function label(row){var loc=locale();return row[loc]||row.en||row.de}function ensureBox(){return box||(box=document.createElement("div"),box.id="lx-vgkl-suggest",box.style.cssText="display:none;position:absolute;z-index:80;background:#fff;border:1px solid #e2e8e6;border-radius:12px;box-shadow:0 8px 24px rgba(14,26,34,.08);max-height:320px;overflow:auto;min-width:280px;padding:8px 0;",document.body.appendChild(box),box)}function go(row){var root=window.routes&&window.routes.rootUrl||"/";root==="/"?root="":root=root.replace(/\/$/,"");var url2=root+"/search?q="+encodeURIComponent(row.en);window.location.href=url2}function render(q,input){if(!DATA||!q||q.length<2){ensureBox().style.display="none";return}var ql=q.toLowerCase(),hits=DATA.filter(function(r){return r.de&&r.de.toLowerCase().indexOf(ql)>=0||r.en&&r.en.toLowerCase().indexOf(ql)>=0||r.nl&&r.nl.toLowerCase().indexOf(ql)>=0||r.fr&&r.fr.toLowerCase().indexOf(ql)>=0}).slice(0,12),b=ensureBox();if(!hits.length){b.style.display="none";return}b.innerHTML='<div style="padding:6px 14px;font-size:11px;letter-spacing:.04em;text-transform:uppercase;color:#5b6b73;">Categories</div>'+hits.map(function(r){return'<button type="button" data-en="'+r.en.replace(/"/g,"&quot;")+'" style="display:block;width:100%;text-align:left;border:0;background:#fff;padding:8px 14px;cursor:pointer;font-size:14px;">'+label(r)+"</button>"}).join("");var rect=input.getBoundingClientRect();b.style.left=rect.left+window.scrollX+"px",b.style.top=rect.bottom+window.scrollY+6+"px",b.style.width=Math.max(rect.width,280)+"px",b.style.display="block",b.querySelectorAll("button").forEach(function(btn){btn.addEventListener("mousedown",function(e){e.preventDefault();var en=btn.getAttribute("data-en"),row=hits.filter(function(h){return h.en===en})[0];row&&go(row)})})}function bind(){var input=document.querySelector(".search-bar__input");!input||input.dataset.lxVgkl||(input.dataset.lxVgkl="1",input.addEventListener("input",function(){render(input.value.trim(),input)}),input.addEventListener("focus",function(){render(input.value.trim(),input)}),document.addEventListener("click",function(e){box&&!box.contains(e.target)&&e.target!==input&&(box.style.display="none")}))}document.addEventListener("focusin",function(e){var t=e.target;if(!t||!t.classList||!t.classList.contains("search-bar__input"))return;bind();if(window.__lxVgklOnce)return;window.__lxVgklOnce=1;fetch(window.lxVgklUrl||"/cdn/shop/t/assets/vgkl-categories.json",{credentials:"same-origin"}).then(function(r){return r.ok?r.json():[]}).then(function(d){DATA=d;if(t)render(t.value.trim(),t)}).catch(function(){})});bind()})();
/* lx-balance-range-filters */
(function () {
  var MASS = { kg: 1, g: 0.001, mg: 1e-6, µg: 1e-9, μg: 1e-9, ug: 1e-9 };
  var VOL = { l: 1000, ml: 1, "µl": 0.001, "μl": 0.001, ul: 0.001 };
  function onBalances() {
    return /\/(?:collections|a\/search)\/balances-and-scales(?:\/|$)/.test(location.pathname);
  }
  function onLiquid() {
    return /\/(?:collections|a\/search)\/liquid-handling(?:\/|$)/.test(location.pathname);
  }
  function onRangePage() {
    return onBalances() || onLiquid();
  }
  function volMl(label) {
    var m = String(label || "").trim().match(/^(\d+(?:[.,]\d+)?)\s*(µl|μl|ul|ml|l)$/i);
    if (!m) return null;
    var n = parseFloat(m[1].replace(",", "."));
    var u = m[2].toLowerCase();
    if (u === "ul" || u === "μl") u = "µl";
    if (VOL[u] == null || !isFinite(n)) return null;
    return n * VOL[u];
  }
  var BALANCE_FILTERS = [
    {
      key: "resolution",
      id: "custom.resolution",
      param: "filter_custom.resolution",
      names: { resolution: 1, resolutie: 1, "résolution": 1, oplossing: 1 }
    },
    {
      key: "load",
      id: "custom.maximum_load",
      param: "filter_custom.maximum_load",
      names: {
        "maximum load": 1,
        "maximale belasting": 1,
        "maximale last": 1,
        "charge maximale": 1
      }
    }
  ];
  var LIQUID_FILTERS = [
    {
      key: "content",
      id: "custom.content",
      param: "filter_custom.content",
      names: { content: 1, inhoud: 1, contenu: 1 },
      parse: volMl
    }
  ];
  var FILTERS = onLiquid() ? LIQUID_FILTERS : BALANCE_FILTERS;
  var BRAND = { brand: 1, merk: 1, marque: 1 };
  var STOCK = {
    "in stock": 1,
    "out of stock": 1,
    lagerbestand: 1,
    voorraad: 1,
    availability: 1,
    stock: 1,
    "en stock": 1,
    "op voorraad": 1,
    "disponibilité": 1,
    disponible: 1
  };
  function norm(s) {
    return (s || "").replace(/\s+/g, " ").trim().toLowerCase();
  }
  function pillName(el) {
    var name = el.querySelector(".cloud-search-filter__name");
    if (!name) return "";
    var copy = name.cloneNode(true);
    copy.querySelectorAll(".cloud-search-applied-filter__text").forEach(function (n) {
      n.remove();
    });
    return norm(copy.textContent);
  }
  function pills() {
    return [].slice.call(document.querySelectorAll(
      ".cloud-search-filter.cloud-search-filter--rounded, .cloud-search-filters-column > .cloud-search-filter"
    ));
  }
  function readVals(root) {
    if (!root) return [];
    var seen = {};
    var out = [];
    [].slice.call(root.querySelectorAll("[data-filter-value]")).forEach(function (el) {
      var label = el.getAttribute("data-filter-value");
      if (!label || seen[label]) return;
      seen[label] = 1;
      out.push(label);
    });
    return out;
  }
  function massKg(label) {
    var m = String(label || "").trim().match(/^(\d+(?:[.,]\d+)?)\s*(µg|μg|ug|mg|g|kg)$/i);
    if (!m) return null;
    var n = parseFloat(m[1].replace(",", "."));
    var u = m[2].toLowerCase();
    if (!MASS[u] || !isFinite(n)) return null;
    return n * MASS[u];
  }
  function selected(param) {
    var out = [];
    var u = new URL(location.href);
    u.searchParams.forEach(function (v, k) {
      if (k === param || k.indexOf(param + "[") === 0) out.push(v);
    });
    return out;
  }
  function sameSet(a, b) {
    if (a.length !== b.length) return false;
    var x = a.slice().sort();
    var y = b.slice().sort();
    for (var i = 0; i < x.length; i++) if (x[i] !== y[i]) return false;
    return true;
  }
  function go(param, labels, total) {
    var u = new URL(location.href);
    var drop = [];
    u.searchParams.forEach(function (_, k) {
      if (k === param || k.indexOf(param + "[") === 0) drop.push(k);
    });
    drop.forEach(function (k) { u.searchParams.delete(k); });
    var narrow = labels && labels.length && labels.length < total;
    if (narrow) {
      if (labels.length === 1) u.searchParams.set(param, labels[0]);
      else labels.forEach(function (lab, i) { u.searchParams.append(param + "[" + i + "]", lab); });
      u.pathname = u.pathname.replace("/collections/", "/a/search/");
    } else {
      var any = false;
      u.searchParams.forEach(function (_, k) {
        if (k.indexOf("filter_") === 0) any = true;
      });
      if (!any) u.pathname = u.pathname.replace("/a/search/", "/collections/");
    }
    u.searchParams.delete("page");
    var next = u.toString();
    if (next !== location.href) reloadGrid(next);
  }
  function harvest(pill, id) {
    var inline = readVals(pill);
    if (inline.length) return Promise.resolve(inline);
    return new Promise(function (resolve) {
      document.documentElement.classList.add("lx-range-harvest");
      window.__lxRangeAllow = 1;
      var name = pill.querySelector(".cloud-search-filter__name");
      if (name) name.click();
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        var box = document.getElementById("cloud-search-filter-values-" + id);
        var more = box && box.querySelector(".cloud-search-filter__more, .cloud-search-filter__show-more");
        if (more && tries < 8) {
          more.click();
          return;
        }
        var vals = box
          ? [].slice.call(box.querySelectorAll("[data-filter-value]")).map(function (el) {
              return el.getAttribute("data-filter-value");
            })
          : [];
        if (vals.length || tries > 25) {
          clearInterval(timer);
          if (name && box) name.click();
          window.__lxRangeAllow = 0;
          document.documentElement.classList.remove("lx-range-harvest");
          resolve(vals);
        }
      }, 120);
    });
  }
  function mount(pill, spec, raw) {
    if (pill.getAttribute("data-lx-range") === "1") return;
    var parsed = [];
    var seen = {};
    raw.forEach(function (label) {
      var kg = (spec.parse || massKg)(label);
      if (kg == null || seen[label]) return;
      seen[label] = 1;
      parsed.push({ label: label, kg: kg });
    });
    parsed.sort(function (a, b) { return a.kg - b.kg; });
    if (parsed.length < 2) {
      var tries = parseInt(pill.getAttribute("data-lx-tries") || "0", 10) + 1;
      pill.setAttribute("data-lx-tries", String(tries));
      if (tries < 4) pill.removeAttribute("data-lx-range");
      else pill.setAttribute("data-lx-range", "skip");
      return;
    }
    pill.setAttribute("data-lx-range", "1");
    pill.setAttribute("data-lx-param", spec.param);
    pill.classList.add("lx-range-filter");
    try {
      window.__lxRangeCache = window.__lxRangeCache || {};
      window.__lxRangeCache[spec.param] = raw.slice();
    } catch (e1) {}
    var current = selected(spec.param);
    var lo = 0;
    var hi = parsed.length - 1;
    if (current.length) {
      var idxs = [];
      current.forEach(function (lab) {
        for (var i = 0; i < parsed.length; i++) if (parsed[i].label === lab) idxs.push(i);
      });
      if (idxs.length) {
        lo = Math.min.apply(null, idxs);
        hi = Math.max.apply(null, idxs);
      }
    }
    var box = document.createElement("div");
    box.className = "lx-range";
    box.innerHTML =
      '<div class="lx-range__readout">' +
      '<span><span class="lx-range__k">Min.</span> <span class="lx-range__min"></span></span>' +
      '<span><span class="lx-range__k">Max.</span> <span class="lx-range__max"></span></span>' +
      "</div>" +
      '<div class="lx-range__track">' +
      '<input class="lx-range__lo" type="range" min="0" max="' + (parsed.length - 1) + '" value="' + lo + '" aria-label="Min. ' + spec.key + '">' +
      '<input class="lx-range__hi" type="range" min="0" max="' + (parsed.length - 1) + '" value="' + hi + '" aria-label="Max. ' + spec.key + '">' +
      "</div>" +
      '<div class="lx-range__scale"><span class="lx-range__scale-min"></span><span class="lx-range__scale-max"></span></div>';
    pill.appendChild(box);
    var loIn = box.querySelector(".lx-range__lo");
    var hiIn = box.querySelector(".lx-range__hi");
    var minEl = box.querySelector(".lx-range__min");
    var maxEl = box.querySelector(".lx-range__max");
    var track = box.querySelector(".lx-range__track");
    box.querySelector(".lx-range__scale-min").textContent = parsed[0].label;
    box.querySelector(".lx-range__scale-max").textContent = parsed[parsed.length - 1].label;
    var timer = 0;
    function paint() {
      var a = Math.min(parseInt(loIn.value, 10), parseInt(hiIn.value, 10));
      var b = Math.max(parseInt(loIn.value, 10), parseInt(hiIn.value, 10));
      minEl.textContent = parsed[a].label;
      maxEl.textContent = parsed[b].label;
      var n = parsed.length - 1;
      var left = n === 0 ? 0 : (a / n) * 100;
      var right = n === 0 ? 100 : (b / n) * 100;
      var mid = left + (right - left) * 0.48;
      track.style.setProperty(
        "--lx-range-fill",
        "linear-gradient(90deg, #d7e3ea 0%, #d7e3ea " + left + "%, #0a3d7a " + left + "%, #0e6b8f " + mid + "%, #14a0b0 " + right + "%, #d7e3ea " + right + "%, #d7e3ea 100%)"
      );
      paintApplied();
      return parsed.slice(a, b + 1).map(function (row) { return row.label; });
    }
    function schedule() {
      var labels = paint();
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (window.__lxRangeSilent) return;
        var now = labels.length === parsed.length ? [] : labels;
        var have = selected(spec.param);
        if (!sameSet(now, have)) go(spec.param, now, parsed.length);
      }, 350);
    }
    loIn.addEventListener("input", schedule);
    hiIn.addEventListener("input", schedule);
    loIn.addEventListener("pointerdown", function () { loIn.style.zIndex = "4"; hiIn.style.zIndex = "3"; });
    hiIn.addEventListener("pointerdown", function () { hiIn.style.zIndex = "4"; loIn.style.zIndex = "3"; });
    paint();
  }
  function hideStock() {
    pills().forEach(function (pill) {
      if (STOCK[pillName(pill)]) pill.style.display = "none";
    });
  }
  function reorder() {
    var parents = [];
    pills().forEach(function (pill) {
      if (pill.parentNode && parents.indexOf(pill.parentNode) < 0) parents.push(pill.parentNode);
    });
    parents.forEach(function (parent) {
      var brand = null;
      var slots = [];
      [].slice.call(parent.children).forEach(function (pill) {
        if (!pill.classList || !pill.classList.contains("cloud-search-filter")) return;
        var name = pillName(pill);
        if (!brand && BRAND[name]) brand = pill;
        for (var i = 0; i < FILTERS.length; i++) {
          if (!slots[i] && FILTERS[i].names[name]) slots[i] = pill;
        }
      });
      var stack = [];
      for (var s = 0; s < FILTERS.length; s++) if (slots[s]) stack.push(slots[s]);
      if (!stack.length) return;
      var already = true;
      for (var j = 0; j < stack.length; j++) {
        var expectNext = j + 1 < stack.length ? stack[j + 1] : brand;
        if (expectNext && stack[j].nextElementSibling !== expectNext) already = false;
      }
      if (already) return;
      var anchor = brand;
      for (var k = stack.length - 1; k >= 0; k--) {
        if (anchor && stack[k] !== anchor) parent.insertBefore(stack[k], anchor);
        anchor = stack[k];
      }
    });
  }

  function esc(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }
  function facetTitle(pill) {
    var name = pill.querySelector(".cloud-search-filter__name");
    if (!name) return "";
    var copy = name.cloneNode(true);
    copy.querySelectorAll(".cloud-search-applied-filter__text").forEach(function (n) { n.remove(); });
    return (copy.textContent || "").replace(/\s+/g, " ").trim();
  }
  function appliedHeading() {
    var l = (document.documentElement.lang || "en").toLowerCase();
    if (l.indexOf("nl") === 0) return "Gefilterd op";
    if (l.indexOf("fr") === 0) return "Filtré sur";
    return "Filtered on";
  }

  /* lx-filtering */
  function filterWord() {
    var l = (document.documentElement.lang || "en").toLowerCase();
    if (l.indexOf("nl") === 0) return "Filteren";
    if (l.indexOf("fr") === 0) return "Filtrage";
    return "Filtering";
  }
  function gridHost() {
    var nodes = document.querySelectorAll(".product-list--collection, .product-list");
    var best = null;
    var area = 0;
    for (var i = 0; i < nodes.length; i++) {
      var r = nodes[i].getBoundingClientRect();
      var a = r.width * Math.max(r.height, 1);
      if (r.width > 40 && a > area) {
        best = nodes[i];
        area = a;
      }
    }
    return best;
  }
  function placeOverlay(el, host) {
    var parent = host.parentNode;
    if (!parent) return;
    if (window.getComputedStyle(parent).position === "static") parent.style.position = "relative";
    if (el.parentNode !== parent) parent.appendChild(el);
    var pr = parent.getBoundingClientRect();
    var hr = host.getBoundingClientRect();
    var height = hr.height;
    if (height < 80) {
      var saved = 0;
      try { saved = parseInt(sessionStorage.getItem("lxFilteringH") || "0", 10); } catch (e) {}
      height = saved > 80 ? saved : 420;
    } else {
      try { sessionStorage.setItem("lxFilteringH", String(Math.round(height))); } catch (e2) {}
    }
    el.style.position = "absolute";
    el.style.left = (hr.left - pr.left + parent.scrollLeft) + "px";
    el.style.top = (hr.top - pr.top + parent.scrollTop) + "px";
    el.style.width = Math.max(hr.width, 0) + "px";
    el.style.height = height + "px";
    var visTop = Math.max(hr.top, 0);
    var visBot = Math.min(hr.top + height, window.innerHeight);
    var center = ((visTop + visBot) / 2) - hr.top;
    el.style.paddingTop = Math.max(center - 36, 28) + "px";
    if (!window.__lxGridScroll) {
      window.__lxGridScroll = 1;
      var move = function () {
        var box = document.getElementById("lx-filtering");
        var grid = collectionList() || gridHost();
        if (box && grid) placeOverlay(box, grid);
      };
      window.addEventListener("scroll", move, { passive: true });
      window.addEventListener("resize", move);
    }
  }
  function paintFiltering() {
    var host = gridHost();
    if (!host) return;
    var el = document.getElementById("lx-filtering");
    if (!el) {
      el = document.createElement("div");
      el.id = "lx-filtering";
      el.setAttribute("role", "status");
      el.setAttribute("aria-live", "polite");
      var spin = document.createElement("div");
      spin.className = "lx-filtering__spin";
      spin.setAttribute("aria-hidden", "true");
      var p = document.createElement("p");
      p.className = "lx-filtering__word";
      p.textContent = filterWord();
      el.appendChild(spin);
      el.appendChild(p);
      document.body.appendChild(el);
    }
    placeOverlay(el, host);
  }
  function armFiltering() {
    try { sessionStorage.setItem("lxFiltering", String(Date.now())); } catch (e) {}
    paintFiltering();
  }
  function hideFiltering() {
    try { sessionStorage.removeItem("lxFiltering"); } catch (e) {}
    var el = document.getElementById("lx-filtering");
    if (el) el.remove();
  }
  /* lx-grid-only: alleen het productraster wisselt */
  function isResultPage(url) {
    try {
      var u = new URL(url, location.href);
      if (u.origin !== location.origin) return false;
      return /\/(?:collections|a\/search)\/[^/]+\/?$/.test(u.pathname);
    } catch (e) { return false; }
  }
  function collectionList() {
    return document.querySelector(".lx-collection-with-filters .product-list--collection")
      || document.querySelector('[data-section-type="collection"] .product-list--collection')
      || document.querySelector(".product-list--collection");
  }
  function applyGrid(doc) {
    var cur = collectionList();
    if (!cur || !doc) return false;
    var incoming = doc.querySelector(".product-list--collection") || doc.querySelector('[data-section-type="collection"] .product-list');
    if (!incoming) {
      if (!doc.querySelector(".collection--empty, .empty-state")) return false;
      cur.innerHTML = "";
    } else {
      cur.innerHTML = incoming.innerHTML;
    }
    var curPage = document.querySelector(".collection .pagination") || document.querySelector(".pagination");
    var newPage = doc.querySelector(".collection .pagination") || doc.querySelector(".pagination");
    if (curPage && newPage) curPage.innerHTML = newPage.innerHTML;
    else if (curPage && !newPage) curPage.innerHTML = "";
    [".collection__products-count-total", ".collection__products-count-showing", ".collection__showing-count"].forEach(function (sel) {
      var a = document.querySelector(sel);
      var b = doc.querySelector(sel);
      if (a && b) a.textContent = b.textContent;
    });
    var sa = document.querySelector("script[data-collection-products-count]");
    var sb = doc.querySelector("script[data-collection-products-count]");
    if (sa && sb) sa.textContent = sb.textContent;
    return true;
  }
  var gridSeq = 0;
  var gridShown = "";
  function reloadGrid(next, opts) {
    opts = opts || {};
    var dest;
    try { dest = new URL(next, location.href).toString(); } catch (e) { return; }
    if (!isResultPage(dest)) {
      location.assign(dest);
      return;
    }
    if (!gridShown) gridShown = location.href;
    if (!opts.force && dest === gridShown) return;
    var seq = ++gridSeq;
    window.__lxGridDest = dest;
    window.__lxGridHoldPush = 1;
    armFiltering();
    var y = window.scrollY;
    var col = document.querySelector(".cloud-search-filters-column") || document.querySelector(".cloud-search-page-controls");
    var colScroll = col ? col.scrollTop : 0;
    fetch(dest, { credentials: "same-origin", headers: { Accept: "text/html" } })
      .then(function (r) {
        if (!r.ok) throw new Error("status");
        return r.text();
      })
      .then(function (html) {
        if (seq !== gridSeq) return;
        var doc = new DOMParser().parseFromString(html, "text/html");
        if (!applyGrid(doc)) throw new Error("grid");
        var prevPath = pathKey(gridShown);
        var prevFilters = filterKey(gridShown);
        gridShown = dest;
        if (opts.history !== false) history.pushState({ lxGrid: 1 }, "", dest);
        if (col && col.isConnected) col.scrollTop = colScroll;
        if (Math.abs(window.scrollY - y) > 1) window.scrollTo(window.scrollX, y);
        hideFiltering();
        paintApplied();
        syncChecks();
        if (prevFilters !== filterKey(dest) || prevPath !== pathKey(dest)) refreshFilters(doc);
      })
      .catch(function () {
        if (seq !== gridSeq) return;
        window.__lxGridHoldPush = 0;
        location.assign(dest);
      })
      .then(function () {
        setTimeout(function () {
          if (seq === gridSeq) window.__lxGridHoldPush = 0;
        }, 800);
      });
  }
  function readFacet(u, param) {
    var out = [];
    u.searchParams.forEach(function (v, k) {
      if (k === param || k.indexOf(param + "[") === 0) out.push(v);
    });
    return out;
  }
  function writeFacet(u, param, values) {
    var drop = [];
    u.searchParams.forEach(function (_, k) {
      if (k === param || k.indexOf(param + "[") === 0) drop.push(k);
    });
    drop.forEach(function (k) { u.searchParams.delete(k); });
    if (values.length === 1) u.searchParams.set(param, values[0]);
    else values.forEach(function (v, i) { u.searchParams.append(param + "[" + i + "]", v); });
  }
  function retarget(u) {
    u.searchParams.delete("page");
    var any = false;
    u.searchParams.forEach(function (_, k) {
      if (k.indexOf("filter_") === 0) any = true;
    });
    if (any) u.pathname = u.pathname.replace("/collections/", "/a/search/");
    else u.pathname = u.pathname.replace("/a/search/", "/collections/");
    return u;
  }
  function rememberFacets() {
    window.__lxFacetByName = window.__lxFacetByName || {};
    document.querySelectorAll("[id^='cloud-search-filter-values-']").forEach(function (box) {
      var id = box.id.slice("cloud-search-filter-values-".length);
      var pill = box.closest("[data-filter-name]");
      var name = pill && pill.getAttribute("data-filter-name");
      if (!name || !id) return;
      window.__lxFacetByName[name] = id;
      window.__lxFacetByName[name.toLowerCase()] = id;
    });
  }
  function facetIdByName(name) {
    rememberFacets();
    var map = window.__lxFacetByName || {};
    if (!name) return "";
    if (map[name]) return map[name];
    return map[name.toLowerCase()] || "";
  }
  function silenceSliders(fn) {
    window.__lxRangeSilent = 1;
    try { fn(); } catch (e) {}
    setTimeout(function () { window.__lxRangeSilent = 0; }, 500);
  }
  function resetSliders(param) {
    silenceSliders(function () {
      document.querySelectorAll(".lx-range-filter").forEach(function (pill) {
        if (param && pill.getAttribute("data-lx-param") !== param) return;
        var lo = pill.querySelector(".lx-range__lo");
        var hi = pill.querySelector(".lx-range__hi");
        if (lo) lo.value = lo.min || "0";
        if (hi) hi.value = hi.max;
        if (lo) lo.dispatchEvent(new Event("input"));
        if (hi) hi.dispatchEvent(new Event("input"));
      });
    });
  }
  function syncChecks() {
    var u;
    try { u = new URL(location.href); } catch (e) { return; }
    rememberFacets();
    document.querySelectorAll("[id^='cloud-search-filter-values-']").forEach(function (box) {
      var id = box.id.slice("cloud-search-filter-values-".length);
      if (!id) return;
      var selected = {};
      readFacet(u, "filter_" + id).forEach(function (v) { selected[v] = 1; });
      var any = false;
      box.querySelectorAll(".cloud-search-filter-value").forEach(function (label) {
        var input = label.querySelector("input");
        if (input && input.type === "radio") return;
        var value = label.getAttribute("data-filter-value");
        var on = !!(value != null && selected[value]);
        if (on) any = true;
        label.classList.toggle("cloud-search-filter-value--selected", on);
        if (input && input.type === "checkbox" && input.checked !== on) input.checked = on;
      });
      var pill = box.closest(".cloud-search-filter");
      if (pill) pill.classList.toggle("cloud-search-filter--active", any);
    });
  }
  /* lx-filter-reopen: closing the list drops the tick. The address still has the choice. */
  function bindSelectionKeep() {
    if (window.__lxSelKeep) return;
    window.__lxSelKeep = 1;
    var wait = 0;
    function soon() {
      clearTimeout(wait);
      wait = setTimeout(function () {
        wait = 0;
        syncChecks();
      }, 80);
    }
    var obs = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var nodes = records[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (!n || n.nodeType !== 1) continue;
          if ((n.id && n.id.indexOf("cloud-search-filter-values-") === 0) ||
              (n.classList && n.classList.contains("cloud-search-filter-value")) ||
              (n.querySelector && n.querySelector(".cloud-search-filter-value, [id^='cloud-search-filter-values-']"))) {
            soon();
            return;
          }
        }
      }
    });
    if (document.documentElement) obs.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener("click", function (e) {
      var t = e.target;
      if (!t || !t.closest || !t.closest(".cloud-search-filter__name")) return;
      soon();
      setTimeout(syncChecks, 240);
    }, true);
    syncChecks();
  }
  function setFacet(facetId, values) {
    var u = new URL(location.href);
    writeFacet(u, "filter_" + facetId, values);
    retarget(u);
    reloadGrid(u.toString());
  }
  function clearColumnChecks() {
    document.querySelectorAll(".cloud-search-filter-value--selected").forEach(function (el) {
      el.classList.remove("cloud-search-filter-value--selected");
      var input = el.querySelector("input");
      if (input && input.type !== "range") input.checked = false;
    });
    document.querySelectorAll(".cloud-search-filter--active").forEach(function (el) {
      el.classList.remove("cloud-search-filter--active");
    });
  }
  function guardFilterColumn() {
    if (window.__lxGridGuard) return;
    window.__lxGridGuard = 1;
    var desc = Object.getOwnPropertyDescriptor(Element.prototype, "innerHTML");
    if (desc && desc.set && desc.configurable) {
      Object.defineProperty(Element.prototype, "innerHTML", {
        configurable: true,
        enumerable: desc.enumerable,
        get: function () { return desc.get.call(this); },
        set: function (value) {
          if (this.isConnected && typeof value === "string" && value.indexOf("product-list") !== -1 && (value.indexOf("cloud_search") !== -1 || value.indexOf("cloud-search") !== -1)) {
            var id = this.id || "";
            if (id.indexOf("shopify-section") === 0 || this.hasAttribute("data-cloud-search-reload")) {
              var parsed = new DOMParser().parseFromString(value, "text/html");
              if (applyGrid(parsed)) return;
            }
          }
          desc.set.call(this, value);
        }
      });
    }
    var origAttr = Element.prototype.removeAttribute;
    Element.prototype.removeAttribute = function (name) {
      if (name === "id" && (this.id === "cloud_search_filters_root" || this.id === "cloud_search_filters_sidebar")) {
        this.setAttribute("data-lx-keep-id", this.id);
      }
      return origAttr.apply(this, arguments);
    };
    var origRemove = Element.prototype.remove;
    Element.prototype.remove = function () {
      var id = this.id || this.getAttribute("data-lx-keep-id") || "";
      if (id === "cloud_search_filters_root" || id === "cloud_search_filters_sidebar") return;
      return origRemove.apply(this, arguments);
    };
    if (Element.prototype.moveBefore) {
      var origMove = Element.prototype.moveBefore;
      Element.prototype.moveBefore = function (node, child) {
        if (node && node.getAttribute) {
          var id = node.id || node.getAttribute("data-lx-keep-id") || "";
          if (id === "cloud_search_filters_root" || id === "cloud_search_filters_sidebar") {
            var keep = node.getAttribute("data-lx-keep-id");
            if (keep && !node.id) node.id = keep;
            return node;
          }
        }
        return origMove.call(this, node, child);
      };
    }
    var origPush = history.pushState.bind(history);
    history.pushState = function (state, title, url) {
      if (window.__lxGridHoldPush && url) {
        try {
          if (new URL(url, location.href).toString() !== window.__lxGridDest) return;
        } catch (err) { return; }
      }
      return origPush(state, title, url);
    };
  }
  function bindGridNav() {
    if (window.__lxGridNav) return;
    window.__lxGridNav = 1;
    window.addEventListener("popstate", function () {
      if (!isResultPage(location.href)) return;
      reloadGrid(location.href, { history: false, force: true });
    });
    document.addEventListener("click", function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var pageLink = t.closest(".pagination a");
      if (pageLink) {
        var href = pageLink.getAttribute("href");
        if (!href || !isResultPage(href)) return;
        e.preventDefault();
        e.stopPropagation();
        reloadGrid(href);
        return;
      }
      if (t.closest(".lx-range-filter, .lx-range-applied__clear")) return;
      if (t.closest(".cloud-search-clear-filters")) {
        e.preventDefault();
        e.stopPropagation();
        clearAllFilters();
        return;
      }
      var chip = t.closest(".cloud-search-applied-filter__clear");
      if (chip) {
        e.preventDefault();
        e.stopPropagation();
        var named = chip.closest("[data-filter-name]");
        var chipId = facetIdByName(named && named.getAttribute("data-filter-name"));
        if (!chipId) { clearAllFilters(); return; }
        resetSliders("filter_" + chipId);
        setFacet(chipId, []);
        return;
      }
      var label = t.closest(".cloud-search-filter-value");
      if (!label || label.closest(".product-item, .product-list")) return;
      var box = label.closest("[id^='cloud-search-filter-values-']");
      if (!box) return;
      var facetId = box.id.slice("cloud-search-filter-values-".length);
      var value = label.getAttribute("data-filter-value");
      if (!facetId || value == null) return;
      e.preventDefault();
      e.stopPropagation();
      var input = label.querySelector("input");
      if (input && input.type === "radio" && (input.name || "").indexOf("sort") === 0) {
        var su = new URL(location.href);
        su.searchParams.set("sort_by", value);
        su.searchParams.delete("page");
        box.querySelectorAll(".cloud-search-filter-value").forEach(function (el) {
          var on = el === label;
          el.classList.toggle("cloud-search-filter-value--selected", on);
          var inp = el.querySelector("input");
          if (inp) inp.checked = on;
        });
        reloadGrid(su.toString());
        return;
      }
      /* lx-filter-box: a click on the square flips checked before this listener. The address is the state. */
      var curNow = readFacet(new URL(location.href), "filter_" + facetId);
      var was = curNow.indexOf(value) !== -1;
      var turningOn = !was;
      if (input && input.type === "radio") {
        box.querySelectorAll(".cloud-search-filter-value").forEach(function (el) {
          var on = turningOn && el === label;
          el.classList.toggle("cloud-search-filter-value--selected", on);
          var inp = el.querySelector("input");
          if (inp && inp.type !== "range") inp.checked = on;
        });
        setFacet(facetId, turningOn ? [value] : []);
      } else {
        label.classList.toggle("cloud-search-filter-value--selected", turningOn);
        if (input && input.type !== "range") input.checked = turningOn;
        var curVals = readFacet(new URL(location.href), "filter_" + facetId).filter(function (v) { return v !== value; });
        if (turningOn) curVals.push(value);
        setFacet(facetId, curVals);
      }
      if (input && t === input && input.type !== "range") {
        var wantChecked = turningOn;
        setTimeout(function () {
          if (input.isConnected) input.checked = wantChecked;
        }, 0);
      }
      var pill = label.closest(".cloud-search-filter");
      if (pill) pill.classList.toggle("cloud-search-filter--active", !!pill.querySelector(".cloud-search-filter-value--selected"));
    }, true);
  }
  function settleFiltering() {
    var on = false;
    try { on = !!sessionStorage.getItem("lxFiltering"); } catch (e) {}
    if (!on && !document.getElementById("lx-filtering")) return;
    if (on) paintFiltering();
    var started = Date.now();
    var timer = setInterval(function () {
      var item = document.querySelector(".product-item");
      var box = item && item.getBoundingClientRect();
      var ready = box && box.height > 20;
      var empty = document.querySelector(".collection--empty, .empty-state");
      var waited = Date.now() - started;
      if ((ready || empty) && waited > 200) {
        clearInterval(timer);
        hideFiltering();
      } else if (waited > 8000) {
        clearInterval(timer);
        hideFiltering();
      }
    }, 80);
  }
  function bindFilterWait() {
    if (window.__lxFilterWait) return;
    window.__lxFilterWait = 1;
    window.addEventListener("beforeunload", function () {
      if (document.getElementById("lx-filtering")) {
        try { sessionStorage.setItem("lxFiltering", String(Date.now())); } catch (e) {}
      }
    });
    document.addEventListener("click", function (e) {
      var t = e.target && e.target.closest && e.target.closest("a, button, input, label, li");
      if (!t || !t.closest) return;
      if (t.closest(".lx-range-filter, .lx-range-applied__clear")) return;
      if (t.closest(".cloud-search-filter__name, .cloud-search-filter__more, .cloud-search-filter__show-more")) return;
      var host = t.closest(".cloud-search-filters-column, .cloud-search-filter, .cloud-search-applied-filter, .cloud-search-applied-filters");
      if (!host) return;
      if (t.closest(".product-item, .product-list")) return;
      armFiltering();
      var here = location.href;
      var token = "";
      try { token = sessionStorage.getItem("lxFiltering") || ""; } catch (err) {}
      setTimeout(function () {
        if (location.href !== here) return;
        try { if ((sessionStorage.getItem("lxFiltering") || "") !== token) return; } catch (err) { return; }
        hideFiltering();
      }, 1800);
    }, true);
  }
  /* lx-filter-refresh: swapping the grid leaves the rail on the previous result. */
  function filterKey(url) {
    try {
      var u = new URL(url, location.href);
      var parts = [];
      u.searchParams.forEach(function (v, k) {
        if (k.indexOf("filter_") === 0) parts.push(k + "=" + v);
      });
      parts.sort();
      return parts.join("&");
    } catch (e) { return ""; }
  }
  function pathKey(url) {
    try { return new URL(url, location.href).pathname; } catch (e) { return ""; }
  }
  function csModule() {
    if (window.__lxCsMod && window.__lxCsMod.render) return window.__lxCsMod;
    try {
      if (!window.__lxCsReq) {
        var chunk = window.webpackChunkcloudsearch_resources;
        if (!chunk || !chunk.push) return null;
        chunk.push([["lx-filter-refresh"], {}, function (r) { window.__lxCsReq = r; }]);
      }
      var mod = window.__lxCsReq && window.__lxCsReq(6009);
      if (mod && mod.render) window.__lxCsMod = mod;
      return window.__lxCsMod || null;
    } catch (e) { return null; }
  }
  function refreshFilters(doc) {
    try {
      var open = document.querySelector(".cloud-search-filter--open[data-filter-name]");
      var openName = open ? (open.getAttribute("data-filter-name") || "") : "";
      var incoming = doc && doc.querySelector && doc.querySelector("#cloudsearch-data");
      var current = document.getElementById("cloudsearch-data");
      if (incoming) {
        var node = document.importNode(incoming, true);
        if (current) current.replaceWith(node);
        else document.body.appendChild(node);
      } else if (current) current.remove();
      var mod = csModule();
      if (!mod) return;
      mod.render(function () {});
      window.__lxFilterRefresh = 1;
      setTimeout(function () {
        if (openName) {
          var pill = null;
          document.querySelectorAll(".cloud-search-filter[data-filter-name]").forEach(function (el) {
            if (!pill && el.getAttribute("data-filter-name") === openName) pill = el;
          });
          var name = pill && pill.querySelector(".cloud-search-filter__name");
          if (name && !pill.classList.contains("cloud-search-filter--open")) name.click();
        }
        syncChecks();
      }, 700);
    } catch (e) {}
  }
  function clearLabel() {
    var l = (document.documentElement.lang || "en").toLowerCase();
    if (l.indexOf("nl") === 0) return "Alle filters wissen";
    if (l.indexOf("fr") === 0) return "Effacer tous les filtres";
    return "Clear all filters";
  }
  function clearAllFilters() {
    var u = new URL(location.href);
    var drop = [];
    u.searchParams.forEach(function (_, k) {
      if (k.indexOf("filter_") === 0) drop.push(k);
    });
    drop.forEach(function (k) { u.searchParams.delete(k); });
    u.pathname = u.pathname.replace("/a/search/", "/collections/");
    u.searchParams.delete("page");
    resetSliders();
    clearColumnChecks();
    var next = u.toString();
    if (next !== location.href) reloadGrid(next);
    else refreshFilters(null);
  }
  function bindClear() {
    if (window.__lxRangeClear) return;
    window.__lxRangeClear = 1;
    document.addEventListener("click", function (e) {
      var btn = e.target && e.target.closest && e.target.closest(".lx-range-applied__clear");
      if (!btn) return;
      e.preventDefault();
      clearAllFilters();
    });
  }
  function specIndex(pill) {
    var name = pillName(pill);
    for (var i = 0; i < FILTERS.length; i++) if (FILTERS[i].names[name]) return i;
    return 9;
  }
  function visibleRanges() {
    var groups = {};
    [].slice.call(document.querySelectorAll(".lx-range-filter")).forEach(function (pill) {
      var key = pillName(pill);
      var known = false;
      for (var i = 0; i < FILTERS.length; i++) if (FILTERS[i].names[key]) known = true;
      if (!known) return;
      var shown = pill.getClientRects().length > 0;
      var cur = groups[key];
      if (!cur || (shown && !cur.shown)) groups[key] = { pill: pill, shown: shown };
    });
    var out = [];
    for (var k in groups) out.push(groups[k].pill);
    out.sort(function (a, b) { return specIndex(a) - specIndex(b); });
    return out;
  }
  function productsHost(grid) {
    var parent = grid.parentNode;
    if (parent && parent.classList && parent.classList.contains("lx-range-products")) return parent;
    var col = document.createElement("div");
    col.className = "lx-range-products";
    parent.insertBefore(col, grid);
    col.appendChild(grid);
    return col;
  }
  function paintApplied() {
    if (!onRangePage()) {
      var gone = document.getElementById("lx-range-applied");
      if (gone) gone.remove();
      return;
    }
    var grid = document.querySelector(".lx-collection-with-filters .product-list--collection, .lx-collection-with-filters .product-list");
    if (!grid) return;
    var rows = [];
    visibleRanges().forEach(function (pill) {
      var lo = pill.querySelector(".lx-range__lo");
      var hi = pill.querySelector(".lx-range__hi");
      var minEl = pill.querySelector(".lx-range__min");
      var maxEl = pill.querySelector(".lx-range__max");
      if (!lo || !hi || !minEl || !maxEl) return;
      var a = parseInt(lo.value, 10);
      var b = parseInt(hi.value, 10);
      var top = parseInt(lo.max, 10);
      if (!isFinite(a) || !isFinite(b) || !isFinite(top)) return;
      if (Math.min(a, b) === 0 && Math.max(a, b) === top) return;
      var title = facetTitle(pill);
      if (!title) return;
      rows.push(title + "\t" + minEl.textContent + "\t" + maxEl.textContent);
    });
    var banner = document.getElementById("lx-range-applied");
    if (!rows.length) {
      if (banner) banner.remove();
      return;
    }
    var host = productsHost(grid);
    if (!banner) {
      banner = document.createElement("div");
      banner.id = "lx-range-applied";
      banner.className = "lx-range-applied";
      banner.setAttribute("role", "status");
    }
    banner.setAttribute("translate", "no");
    banner.classList.add("notranslate");
    var sig = appliedHeading() + "\n" + clearLabel() + "\n" + rows.join("\n");
    var placed = banner.parentNode === host && banner.nextElementSibling === grid;
    if (placed && banner.getAttribute("data-lx-sig") === sig) return;
    if (!placed) host.insertBefore(banner, grid);
    if (banner.getAttribute("data-lx-sig") !== sig) {
      banner.setAttribute("data-lx-sig", sig);
      var html = '<div class="lx-range-applied__bar"><p class="lx-range-applied__head">' + esc(appliedHeading()) + '</p><button type="button" class="lx-range-applied__clear notranslate" translate="no">' + esc(clearLabel()) + "</button></div>";
      rows.forEach(function (row) {
        var parts = row.split("\t");
        html += '<p class="lx-range-applied__row"><span class="lx-range-applied__name">' + esc(parts[0]) + '</span><span class="lx-range-applied__value">' + esc(parts[1]) + " – " + esc(parts[2]) + "</span></p>";
      });
      banner.innerHTML = html;
    }
  }
  var busy = false;
  function run() {
    hideStock();
    if (!onRangePage()) {
      var stale = document.getElementById("lx-range-applied");
      if (stale) stale.remove();
      return;
    }
    if (busy) return;
    reorder();
    paintApplied();
    var pending = [];
    pills().forEach(function (pill) {
      if (pill.getAttribute("data-lx-range") === "1" || pill.getAttribute("data-lx-range") === "wait") return;
      var name = pillName(pill);
      FILTERS.forEach(function (spec) {
        if (spec.names[name]) pending.push({ pill: pill, spec: spec });
      });
    });
    if (!pending.length) return;
    busy = true;
    pending.forEach(function (job) { job.pill.setAttribute("data-lx-range", "wait"); });
    var chain = Promise.resolve();
    pending.forEach(function (job) {
      chain = chain.then(function () {
        var cached = window.__lxRangeCache && window.__lxRangeCache[job.spec.param];
        if (cached && cached.length > 1) {
          mount(job.pill, job.spec, cached);
          return;
        }
        return harvest(job.pill, job.spec.id).then(function (vals) { mount(job.pill, job.spec, vals); });
      });
    });
    chain.then(function () { busy = false; reorder(); paintApplied(); }, function () { busy = false; paintApplied(); });
  }
  var t = 0;
  function watch() {
    if (!document.body || window.__lxRangeObs) return;
    window.__lxRangeObs = new MutationObserver(function () {
      if (t) return;
      t = setTimeout(function () { t = 0; run(); }, 150);
    });
    window.__lxRangeObs.observe(document.body, { childList: true, subtree: true });
  }
  function shield() {
    if (window.__lxRangeShield) return;
    window.__lxRangeShield = 1;
    ["click", "mouseup", "pointerup"].forEach(function (type) {
      window.addEventListener(type, function (e) {
        if (window.__lxRangeAllow) return;
        var node = e.target;
        if (!node || !node.closest || !node.closest(".lx-range-filter")) return;
        if (type === "click") e.preventDefault();
        e.stopPropagation();
      }, true);
    });
  }
  function boot() {
    shield();
    guardFilterColumn();
    bindClear();
    bindFilterWait();
    bindGridNav();
    bindSelectionKeep();
    window.__lxFacetByName = window.__lxFacetByName || {};
    FILTERS.forEach(function (spec) {
      Object.keys(spec.names).forEach(function (n) { window.__lxFacetByName[n] = spec.id; });
    });
    settleFiltering();
    if (onRangePage()) document.documentElement.classList.add("lx-range-page");
    if (onLiquid()) document.documentElement.classList.add("lx-liquid-range");
    watch();
    run();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();



(function(){
  function loggedIn(){return !!document.querySelector("[data-lx-logged-in]")}
  function label(){
    var sample=document.querySelector("a.lx-login-price");
    var text=sample?(sample.textContent||"").replace(/\s+/g," ").trim():"";
    if(text) return text;
    var lang=(document.documentElement.lang||"").toLowerCase();
    if(lang.indexOf("nl")===0) return "Log in voor prijs";
    if(lang.indexOf("fr")===0) return "Connexion pour le prix";
    return "Login for price";
  }
  function loginHref(productPath){
    var sample=document.querySelector("a.lx-login-price");
    if(sample){
      try{
        var u=new URL(sample.getAttribute("href")||"", location.origin);
        u.searchParams.set("return_to", productPath);
        return u.pathname+u.search;
      }catch(e){}
    }
    var root=(window.routes&&window.routes.rootUrl)||"/";
    if(root.slice(-1)!=="/") root+="/";
    return root+"customer_authentication/login?return_to="+encodeURIComponent(productPath);
  }
  function isNexo(box){
    var title=box.querySelector(".cs-item-title, .name");
    var text=((title&&title.textContent)||"").toLowerCase();
    if(text.indexOf("nexopart")!==-1) return true;
    var item=box.closest(".cs-item");
    var href=((item&&item.getAttribute("href"))||"").toLowerCase();
    return href.indexOf("nexopart")!==-1;
  }
  function productPath(box){
    var item=box.closest(".cs-item");
    if(!item) item=document.querySelector(".cs-item[aria-selected='true']")||document.querySelector(".cs-item");
    var href=item&&item.getAttribute("href");
    if(!href){
      var link=box.querySelector("a[href*='/products/']");
      href=link&&link.getAttribute("href");
    }
    if(!href) return location.pathname;
    try{return new URL(href, location.origin).pathname}catch(e){return href}
  }
  function replaceBox(box){
    if(!isNexo(box)) return;
    var prices=box.querySelectorAll(".price, .cs-list-price, .cs-price-block");
    if(!prices.length) return;
    var path=productPath(box);
    var href=loginHref(path);
    var nested=!!box.closest("a");
    var node=document.createElement(nested?"span":"a");
    node.className="lx-login-price button button--secondary button--small";
    node.textContent=label();
    if(nested){
      node.setAttribute("role","link");
      node.addEventListener("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        window.location.assign(href);
      });
    }else{
      node.rel="nofollow";
      node.href=href;
    }
    prices[0].parentNode.insertBefore(node, prices[0]);
    prices.forEach(function(p){p.remove()});
  }
  function scan(){
    if(loggedIn()) return;
    document.querySelectorAll(".details-top-text, .cs-item-details").forEach(replaceBox);
  }
  var timer=0;
  var obs=new MutationObserver(function(muts){
    if(loggedIn()) return;
    var hit=false;
    for(var i=0;i<muts.length && !hit;i++){
      var target=muts[i].target;
      if(target.closest && target.closest(".cloud-search-results, .cloud-search-mobile, .details-top")){hit=true;break}
      var added=muts[i].addedNodes;
      for(var j=0;j<added.length;j++){
        var node=added[j];
        if(node.nodeType!==1) continue;
        if((node.matches && node.matches(".cloud-search-results, .cloud-search-mobile, .details-top, .details-top-text, .cs-item-details")) || (node.querySelector && node.querySelector(".details-top-text, .cs-price-block, .cloud-search-results"))){hit=true;break}
      }
    }
    if(!hit || timer) return;
    timer=setTimeout(function(){timer=0;scan()},40);
  });
  function boot(){
    if(!document.body || window.__lxNexoSearch) return;
    window.__lxNexoSearch=1;
    obs.observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();

//# sourceMappingURL=/cdn/shop/t/30/assets/custom.js.map?v=145113579863861637471789971422
